import { Injectable, inject } from '@angular/core';
import { HttpService } from '@nha/api/shared';
import { IPortalLink } from '../types/portal-link.type';
import { CoreApiConfiguration } from '../core-api-configuration.class';
import { Observable } from 'rxjs';
import { IPortalLinkGroup } from '../types/portal-link-group.type';
import { IPortalLinkRequest } from '../types/portal/portal-link-request.type';
import { IPortalLinkLocation } from '../types/portal/portal-link-location.type';
import { IPortalLinkRoleResponse } from '../types/portal/portal-link-role-response.type';

@Injectable({
	providedIn: 'root'
})
export class PortalLinkService extends HttpService {
	constructor() {
		const config = inject(CoreApiConfiguration);

		super(config, 'portallink');
	}

	getForKey(key: string): Observable<IPortalLink> {
		return this.http.get<IPortalLink>(`${this.serviceUrl}/key/${key}`);
	}

	getForUser(): Observable<IPortalLink[]> {
		return this.http.get<IPortalLink[]>(`${this.serviceUrl}/user`);
	}

	toggleFavorite(portalLinkID: number): Observable<number[]> {
		return this.http.put<number[]>(`${this.serviceUrl}/favorites/toggle/${portalLinkID}`, {});
	}

	getPortalLinkGroups(isAdmin: boolean = false): Observable<IPortalLinkGroup[]> {
		return this.http.get<IPortalLinkGroup[]>(`${this.serviceUrl}/portalLinkGroups/${isAdmin}`);
	}

	updateFavoritesOrder(portalLinks: IPortalLink[]): Observable<IPortalLink[]> {
		return this.http.post<IPortalLink[]>(`${this.serviceUrl}/updateFavoritesOrder`, portalLinks);
	}

	updateQuickLinksOrder(portalLinks: IPortalLink[]): Observable<IPortalLink[]> {
		return this.http.post<IPortalLink[]>(`${this.serviceUrl}/updateQuickLinksOrder`, portalLinks);
	}

	updateGroupsOrder(portalLinkGroups: IPortalLinkGroup[]): Observable<IPortalLinkGroup[]> {
		return this.http.post<IPortalLinkGroup[]>(`${this.serviceUrl}/updateGroupsOrder`, portalLinkGroups);
	}

	getPortalLinkRoles(): Observable<IPortalLinkRoleResponse> {
		return this.get(`${this.serviceUrl}/roles`, { snackbarErrorMessage: 'There was an error loading portal link roles.' });
	}

	getPortalLinkLocations(): Observable<IPortalLinkLocation[]> {
		return this.get(`${this.serviceUrl}/locations`, { snackbarErrorMessage: 'There was an error loading portal link locations.' });
	}

	createPortalLink(portalLink: IPortalLinkRequest): Observable<IPortalLink[]> {
		return this.post<IPortalLink[]>(`${this.serviceUrl}/link`, portalLink, { snackbarErrorMessage: 'There was an error creating the portal link.' });
	}

	updatePortalLink(portalLink: IPortalLinkRequest): Observable<IPortalLink[]> {
		return this.put<IPortalLink[]>(`${this.serviceUrl}/link`, portalLink, { snackbarErrorMessage: 'There was an error editing the portal link.' });
	}

	createPortalGroup(portalLinkGroup: IPortalLinkGroup): Observable<IPortalLinkGroup[]> {
		return this.post<IPortalLinkGroup[]>(`${this.serviceUrl}/group`, portalLinkGroup, {
			snackbarErrorMessage: 'There was an error creating the portal group.'
		});
	}

	updatePortalGroup(portalLinkGroup: IPortalLinkGroup): Observable<IPortalLinkGroup[]> {
		return this.put<IPortalLinkGroup[]>(`${this.serviceUrl}/group`, portalLinkGroup, {
			snackbarErrorMessage: 'There was an error editing the portal group.'
		});
	}
}
